import { map, pathOr, pipe, path, prop, indexBy } from 'ramda';
import { getShops } from '../../../../auth/selectors';

export const getPoLocation = (state, id) => pathOr(
  null, ['products', 'purchaseOrders', 'locations', 'byId', id], state
);

export const getPoLocationIds = pathOr([], ['products', 'purchaseOrders', 'locations', 'list']);

export const getPoLocations = state => pipe(
  getPoLocationIds,
  map(id => getPoLocation(state, id)),
)(state);

export const isLoadingLocations = path(['products', 'purchaseOrders', 'locations', 'loading']);

export const getBrandAddress = (state) => {
  const brandAddress = pathOr(null, ['auth', 'user', 'brand', 'address'], state);
  return brandAddress ? [brandAddress] : [];
};

export const getShopAddresses = pipe(
  getShops,
  map(prop('address'))
);

export const getAddresses = state => [...getBrandAddress(state), ...getShopAddresses(state)];

export const getAddressesById = pipe(
  getAddresses,
  indexBy(prop('id'))
);
